import React, { useEffect, useState } from 'react'
import { CircularProgress, Grid, Typography } from '@material-ui/core'
import { useCadaverService } from 'hooks/useCadaverService'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import useStyles from './styles'

export const DetailPanel = (props) => {
  const { idCadaverSelecionado } = props
  moment.locale('pt-br', localization)
  const cadaverService = useCadaverService()
  const [processandoCadaveres, setProcessandoCadaveres] = useState(false)
  const [cadaveres, setCadaveres] = useState(null)
  const classes = useStyles()

  useEffect(() => {
    const fetchCadaveres = async () => {
      const response = await cadaverService.listarCadaverAsync(
        idCadaverSelecionado,
        setProcessandoCadaveres
      )
      setCadaveres(response)
    }

    if (idCadaverSelecionado && idCadaverSelecionado >= 0) {
      fetchCadaveres()
    }
  }, [idCadaverSelecionado])

  return (
    <div>
      {processandoCadaveres || !cadaveres ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container className={classes.container} spacing={1}>
          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Caso relacionado</Typography>
            <Typography className={classes.value}>
              {cadaveres.caso?.identificador || '-'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Descrição do Cadáver</Typography>
            <Typography className={classes.value}>
              {cadaveres.descricaoGeral || 'Não informado'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Endereço de Origem</Typography>
            <Typography className={classes.value}>
              {cadaveres.endOrig
                ? `${cadaveres.endOrig.rua || ''}, ${cadaveres.endOrig.numero || ''} - ${cadaveres.endOrig.bairro || ''} - ${cadaveres.endOrig.cidade || ''}/${cadaveres.endOrig.estado || ''}`
                : 'Não informado'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Necrotério</Typography>
            <Typography className={classes.value}>
              {cadaveres.necroterio
                ? `${cadaveres.necroterio.nome || ''} / ${cadaveres.necroterio.divisao?.sigla || ''} / ${cadaveres.necroterio.divisao?.regional?.nome || ''}`
                : 'Não informado'}
            </Typography>
          </Grid>
        </Grid>
      )}
    </div>
  )
}
